const keyOrder = ['category', 'subCategory', 'productType'];

export default keyOrder;
